/**
 * Reads a student document field by any of the given names.
 * Firestore field names are case-sensitive; scanners sometimes write
 * Grade / Variant / studentId instead of grade / variant / student_id.
 */
export function pickStudentField(data: Record<string, any> | null | undefined, ...names: string[]): any {
  if (!data) return undefined;

  const lowerToActual = new Map<string, string>();
  for (const key of Object.keys(data)) {
    const lower = key.toLowerCase();
    if (!lowerToActual.has(lower)) lowerToActual.set(lower, key);
  }

  for (const name of names) {
    const direct = data[name];
    if (direct !== undefined && direct !== null && String(direct).trim() !== '') {
      return direct;
    }
    const actual = lowerToActual.get(name.toLowerCase());
    if (!actual) continue;
    const value = data[actual];
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      return value;
    }
  }

  return undefined;
}

/**
 * Copies Q## and Q##_c fields onto canonical keys (Q26, Q26_c).
 * The grading UI only reads those canonical names.
 */
export function collectQuestionFields(data: Record<string, any> | null | undefined): Record<string, any> {
  const out: Record<string, any> = {};
  if (!data) return out;

  for (const key of Object.keys(data)) {
    const match = key.match(/^q(\d+)(_c)?$/i);
    if (!match) continue;
    const normalized = `Q${match[1]}${match[2] ? '_c' : ''}`;
    out[normalized] = data[key];
  }

  return out;
}

export function isBlankGroup(value: unknown): boolean {
  if (value === undefined || value === null) return true;
  const text = String(value).trim();
  return text === '' || text === '-';
}
